import { useMemo, useState } from 'react';
import { ExternalLink, MapPin, Trash2 } from 'lucide-react';
import LocationPickerModal from './LocationPickerModal';

const toCoordinate = (value) => {
  if (value === null || value === undefined || value === '') return null;
  const numericValue = Number(value);
  return Number.isFinite(numericValue) ? numericValue : null;
};

const formatCoordinate = (value) => {
  const coordinate = toCoordinate(value);
  return coordinate === null ? '' : coordinate.toFixed(6);
};

const LocationPickerField = ({ direccion, fieldPrefix, errors = {}, onChange }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const coordinates = useMemo(() => {
    const lat = toCoordinate(direccion?.latitud);
    const lng = toCoordinate(direccion?.longitud);
    return lat !== null && lng !== null ? { lat, lng } : null;
  }, [direccion?.latitud, direccion?.longitud]);

  const errorMessage = errors[`${fieldPrefix}.latitud`] || errors[`${fieldPrefix}.longitud`];

  const handleConfirm = ({ lat, lng }) => {
    onChange(`${fieldPrefix}.latitud`, lat);
    onChange(`${fieldPrefix}.longitud`, lng);
    onChange(`${fieldPrefix}.precision_mapa`, true);
    setIsModalOpen(false);
  };

  const handleClear = () => {
    onChange(`${fieldPrefix}.latitud`, null);
    onChange(`${fieldPrefix}.longitud`, null);
    onChange(`${fieldPrefix}.precision_mapa`, false);
  };

  const handleOpenGoogleMaps = () => {
    if (!coordinates) return;
    window.open(`https://www.google.com/maps?q=${coordinates.lat},${coordinates.lng}`, '_blank');
  };

  return (
    <div className="mt-5 rounded-lg border border-slate-200 bg-slate-50 p-4">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div>
          <h4 className="text-sm font-semibold uppercase tracking-[0.08em] text-slate-700">
            Ubicación en mapa
          </h4>
          <p className={`mt-1 text-sm font-medium ${coordinates ? 'text-emerald-700' : 'text-slate-500'}`}>
            {coordinates ? 'Ubicación seleccionada' : 'Ubicación no seleccionada'}
          </p>
          {coordinates && (
            <p className="mt-1 text-xs text-slate-600">
              {formatCoordinate(coordinates.lat)}, {formatCoordinate(coordinates.lng)}
            </p>
          )}
          {errorMessage && <p className="mt-2 text-xs font-medium text-red-600">{errorMessage}</p>}
        </div>

        <div className="flex flex-wrap gap-2">
          <button
            type="button"
            onClick={() => setIsModalOpen(true)}
            className="inline-flex items-center gap-2 rounded-lg bg-red-600 px-3 py-2 text-xs font-semibold text-white transition hover:bg-red-700"
          >
            <MapPin size={15} />
            Seleccionar ubicación en mapa
          </button>
          {coordinates && (
            <>
              <button
                type="button"
                onClick={handleOpenGoogleMaps}
                className="inline-flex items-center gap-2 rounded-lg bg-slate-800 px-3 py-2 text-xs font-semibold text-white transition hover:bg-slate-900"
              >
                <ExternalLink size={15} />
                Ver en Google Maps
              </button>
              <button
                type="button"
                onClick={handleClear}
                className="inline-flex items-center gap-2 rounded-lg bg-slate-200 px-3 py-2 text-xs font-semibold text-slate-800 transition hover:bg-slate-300"
              >
                <Trash2 size={15} />
                Quitar ubicación
              </button>
            </>
          )}
        </div>
      </div>

      <LocationPickerModal
        isOpen={isModalOpen}
        initialCoordinates={coordinates}
        onCancel={() => setIsModalOpen(false)}
        onConfirm={handleConfirm}
      />
    </div>
  );
};

export default LocationPickerField;
